module.exports = __webpack_public_path__ + "img/image9.930065e5.jpeg";